import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Categories from '../components/Categories';
import HowItWorks from '../components/HowItWorks';
import PromoBanners from '../components/PromoBanners';
import Footer from '../components/Footer';
import CartDrawer from '../components/CartDrawer';
import { categories } from '../mock/mock';
import { useToast } from '../hooks/use-toast';

const Home = () => {
  const [selectedCat, setSelectedCat] = useState(null);
  const { toast } = useToast();

  const handleAddressSearch = (address) => {
    toast({ title: 'Indirizzo impostato', description: address ? `Consegna a: ${address}` : 'Mostriamo i ristoranti vicino a te.' });
  };

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <Hero onSearch={handleAddressSearch} />
      <Categories categories={categories} selected={selectedCat} onSelect={setSelectedCat} />
      <HowItWorks />
      <PromoBanners />
      <Footer />
      <CartDrawer />
    </div>
  );
};

export default Home;
